import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"

interface CustomModalProps {
    showModal: boolean,
    header: string,
    body: string,
    onConfirm: () => void,
    onDecline: () => void,
    confirmBtn: {text: string, color: "theme" | "secondary" | "danger"},
    declineBtn: {text: string, color: "theme" | "secondary" | "danger"},
}

const CustomModal = ({ showModal, header, body, onConfirm, onDecline, confirmBtn, declineBtn }: CustomModalProps) => {
  return (
    <Modal show={showModal} cen size="lg" style={{ zIndex: 1061 }} centered>
        <Modal.Header>
            <Modal.Title className="w-100">{ header }</Modal.Title>
        </Modal.Header>

        <Modal.Body>
            <p className="text-center">{ body }</p>
        </Modal.Body>

        <Modal.Footer>
            <Button variant={declineBtn.color} onClick={onDecline}>{ declineBtn.text }</Button>
            <Button variant={confirmBtn.color} onClick={onConfirm}>{ confirmBtn.text }</Button>
        </Modal.Footer>
    </Modal>
  )
}

export default CustomModal
